import SVG from 'Components/SVG';
import { drivingCategoryType } from 'Shared/models/UserModel';
import { SVG_TYPE } from 'Shared/enums';

type SingleCategoryProps = {
  onClick?: (value: number) => void;
  selectedCategory?: number | null;
  category: drivingCategoryType;
};

function SingleCategory({ onClick, selectedCategory, category }: SingleCategoryProps) {
  return (
    <div
      className={`single-category ${selectedCategory === category.value ? 'single-category--selected' : ''}`}
      onClick={() => onClick && onClick(category.value)}>
      <p>Kat {category.label}</p>
      <SVG type={SVG_TYPE.CHEVRON_RIGHT} />
    </div>
  );
}

export default SingleCategory;
